export default __webpack_public_path__ + "static/media/Home-foto-header-incoming-Tower-viajes-mobile.0469fd8a.jpg";